/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoutinesResponse } from '../../models/routines-response';

export interface GetRoutines$Params {
  agent_id: string;
}

export function getRoutines(http: HttpClient, rootUrl: string, params: GetRoutines$Params, context?: HttpContext): Observable<StrictHttpResponse<RoutinesResponse>> {
  const rb = new RequestBuilder(rootUrl, getRoutines.PATH, 'get');
  if (params) {
    rb.query('agent_id', params.agent_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoutinesResponse>;
    })
  );
}

getRoutines.PATH = '/routines';
